var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-btn text-center",on:{"click":function($event){return _vm.goToHome()}}},[_c('span',[_vm._v(" Back"),_c('br'),_c('b-icon',{staticClass:"icon",attrs:{"icon":"basket-fill"}}),_c('br'),_vm._v(" Shopping ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }